import useSound from "use-sound";
import React from "react";
import toastSound from "../assets/sounds/toast.mp3";
import warningSound from "../assets/sounds/warning.mp3";
import requestSound from "../assets/sounds/request.mp3";
import confirmSound from "../assets/sounds/confirm.mp3";
import {accountInfo} from "../constants/constants";

export class SoundPlayerHandle {
  playSoundFunc = null;
  _playQueue = null;

  play(path, type, alarmVolume) {
    if (this.playSoundFunc !== null) {
      this._playQueue = null;
      this.playSoundFunc(path, type, alarmVolume);
      return;
    }
    this._playQueue = {path: path, type: type, alarmVolume:alarmVolume};
  }

  initModule = (playSound) => {
    this.playSoundFunc = playSound;
    let p = this._playQueue;
    this._playQueue = null;
    if (p !== null)
      this.play(p.path, p.type, p.alarmVolume);
  }
}

export let SoundOption = {
  // 옵션별로 사운드 조작
  all_mute: "false",
  signup_alarm: "false"
};

export const SoundPlayer = ({initPlayerHandle}) => {
  const [, warningAlarmSound] = useSound(warningSound);
  const [, confirmAlarmSound] = useSound(confirmSound);
  const [, requestAlarmSound] = useSound(requestSound);
  const [, toastAlarmSound] = useSound(toastSound);

  function _playSound(path, type,alarmVolume) {
    alarmVolume=alarmVolume/100;

    if(alarmVolume ===0)
      return;

    if (accountInfo.getUserConfig().isOn('on_mute', false))
      return;
    if (SoundOption.all_mute === "true") {
      return;
    }
    if (path === "signup") {
      if (SoundOption.signup_alarm === "true") {
        return;
      }
    }
    if (type === "noti") {
      confirmAlarmSound.sound?.volume(alarmVolume);
      confirmAlarmSound.sound?.play();
      // confirmAlarm();
    }
    if (type === "warning") {
      warningAlarmSound.sound?.volume(alarmVolume);
      warningAlarmSound.sound?.play();
      // warningAlarm();
    }
    if (type === "confirm") {
      confirmAlarmSound.sound?.volume(alarmVolume);
      confirmAlarmSound.sound?.play();
      // confirmAlarm();
    }
    if (type === "toast") {
      toastAlarmSound.sound?.volume(alarmVolume);
      toastAlarmSound.sound?.play();
      // toastAlarm();
    }
    if (type === "request") {
      requestAlarmSound.sound?.volume(alarmVolume);
      requestAlarmSound.sound?.play();
      // requestAlarm();
    }
  }

  initPlayerHandle.initModule(_playSound);
  return (<></>);
};